import renderIcon from 'icon';
import QUERY_KEYS from 'network/config/queryKeys';
import { getFavouriteProducts } from 'network/services/goods';
import { ProductsGrid } from 'pages/Products';
import { IoArrowBackCircleSharp } from 'react-icons/io5';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { FavouriteProductsResponse } from 'TYPES/api.body';
import { FavouriteCON } from './styles';

export const Favourite = () => {
  const navigate = useNavigate();
  const { data, isLoading } = useQuery<FavouriteProductsResponse>({
    queryFn: getFavouriteProducts,
    queryKey: [QUERY_KEYS.FAVOURITE_PRODUCTS]
  });

  const products = data?.data ?? [];

  return (
    <>
      <div className="flex items-center gap-2 text-sm text-gray-500 mb-3">
        {renderIcon(IoArrowBackCircleSharp, {
          size: 24,
          className: 'text-black flex-shrink-0 cursor-pointer hover:text-gray-600 transition-colors',
          onClick: () => navigate('/account')
        })}
        <span
          className="font-semibold"
          style={{ color: '#222', cursor: 'pointer' }}
          onClick={() => navigate('/account')}>
          Account
        </span>
        <span>›</span>
        <span className="font-semibold" style={{ color: '#222' }}>
          Favourites
        </span>
      </div>
      <FavouriteCON>
        <div className="header">My Favourites</div>
        <ProductsGrid
          emptyText="You have no favourites"
          isLoading={isLoading}
          products={products.map(item => ({
            productId: item.productId,
            productName: item.productName,
            price: item.price,
            quantityAvailable: item.quantityAvailable,
            minimumOrderQuantity: item.minimumOrderQuantity,
            bulkOrderPrice: item.bulkOrderPrice,
            barCode: item.barCode,
            productImage1:
              (item.images as string[])?.length > 0 ? (item.images as string[])[0] : '/graphics/madina.svg',
            productImage2: (item.images as string[])?.length > 1 ? (item.images as string[])[1] : undefined,
            productImage3: (item.images as string[])?.length > 2 ? (item.images as string[])[2] : undefined,
            likes: item.likes,
            status: item.status,
            description: item.description ?? '',
            seller: {
              seller_logo: item.seller.seller_logo ?? '/graphics/madina.svg',
              businessName: item.seller.businessName,
              id: item.seller.id
            },
            category: item.category
          }))}
          showEmptyPrompt={true}
        />
      </FavouriteCON>
    </>
  );
};
